import { helper } from '@ember/component/helper';
import { GlyphIcon } from '@square/dashboard-protos/models/squareup/inflows/service/external_instant_access_service';
function getInstantAccessSvgName([num]) {
  switch (num) {
    case GlyphIcon.DOORDASH:
      return 'doordash';
    case GlyphIcon.UBER_EATS:
      return 'uber-eats';
    case GlyphIcon.GRUBHUB:
      return 'grubhub';
    default:
      return '';
  }
}
export default helper(getInstantAccessSvgName);